module.exports = __webpack_public_path__ + "img/pf.2cc4e51a.svg";